import { useContext } from "react";
import { Link } from "react-router-dom";
import { Home, Package, Users, BarChart2, Smartphone, MessageSquare, GitBranch, Crosshair, Camera, Megaphone } from "lucide-react";
import { SidebarContext } from "../../../context/SidebarContext";


export default function SidebarMobile() {

    const { location } = useContext(SidebarContext);
    const { leadsOpen, setLeadsOpen } = useContext(SidebarContext);
    const { produtosOpen, setProdutosOpen } = useContext(SidebarContext);
    const { relatoriosOpen, setRelatoriosOpen } = useContext(SidebarContext);
    const { whatsappOpen, setWhatsappOpen } = useContext(SidebarContext);
    const { instagramOpen, setInstagramOpen } = useContext(SidebarContext);
    const { trackingOpen, setTrackingOpen } = useContext(SidebarContext);
    const { adsOpen, setAdsOpen } = useContext(SidebarContext);


    function fecharTodos() {
        setLeadsOpen(false);
        setProdutosOpen(false);
        setRelatoriosOpen(false);
        setWhatsappOpen(false);
        setInstagramOpen(false);
        setTrackingOpen(false);
        setAdsOpen(false);
    }

    function toggleSubmenu(setter, atual) {
        fecharTodos();
        setter(!atual);
    }

    const isAt = (test) => typeof test === "function" ? test(location.pathname) : location.pathname === test;


    return (
        <nav className="sm:hidden h-16 w-full fixed bottom-0 z-[1000] bg-surface-1/85 backdrop-blur-xl border-t border-white/[0.06] flex items-stretch text-ink-3">

            <BottomItem to="/" icon={Home} label="Início" active={isAt("/")} onClick={fecharTodos} />
            <BottomItem to="/chat" icon={MessageSquare} label="Chat" active={isAt("/chat")} onClick={fecharTodos} />
            <BottomItem to="/automacoes" icon={GitBranch} label="Fluxos"
                active={isAt((p) => p === "/automacoes" || (p.includes("/editar") && !p.startsWith("/agentes")))}
                onClick={fecharTodos} />

            <BottomGroup icon={Smartphone} label="WA"
                active={isAt((p) => p.startsWith("/whatsapp") || p.startsWith("/agentes") || p === "/configuracoes/ia")}
                open={whatsappOpen}
                onClick={() => toggleSubmenu(setWhatsappOpen, whatsappOpen)} />

            <BottomGroup icon={Camera} label="IG"
                active={isAt((p) => p.startsWith("/instagram"))}
                open={instagramOpen}
                onClick={() => toggleSubmenu(setInstagramOpen, instagramOpen)} />

            <BottomGroup icon={Users} label="Leads"
                active={isAt((p) => p === "/leads" || p === "/leads/quentes" || p === "/tags")}
                open={leadsOpen}
                onClick={() => toggleSubmenu(setLeadsOpen, leadsOpen)} />

            <BottomGroup icon={BarChart2} label="Stats"
                active={isAt((p) => ["/relatorios/orderbumps", "/relatorio-grupo", "/vendas", "/relatorio-produtos", "/analise-comparativa"].includes(p))}
                open={relatoriosOpen}
                onClick={() => toggleSubmenu(setRelatoriosOpen, relatoriosOpen)} />

            <BottomGroup icon={Crosshair} label="Track"
                active={isAt((p) => p.startsWith("/tracking"))}
                open={trackingOpen}
                onClick={() => toggleSubmenu(setTrackingOpen, trackingOpen)} />

            <BottomGroup icon={Megaphone} label="Ads"
                active={isAt((p) => p.startsWith("/ads"))}
                open={adsOpen}
                onClick={() => toggleSubmenu(setAdsOpen, adsOpen)} />

            <BottomGroup icon={Package} label="Prod"
                active={isAt((p) => p === "/produtos" || p === "/grupos" || p === "/gastos")}
                open={produtosOpen}
                onClick={() => toggleSubmenu(setProdutosOpen, produtosOpen)} />

            {whatsappOpen && (
                <Drawer onClose={() => setWhatsappOpen(false)}>
                    <DrawerLink to="/whatsapp/chat" label="Chat das sessões" active={isAt((p) => p.startsWith("/whatsapp/chat"))} onClick={() => setWhatsappOpen(false)} />
                    <DrawerLink to="/whatsapp/campanhas" label="Campanhas" active={isAt((p) => p.startsWith("/whatsapp/campanhas"))} onClick={() => setWhatsappOpen(false)} />
                    <DrawerLink to="/whatsapp/fila" label="Fila de Envio" active={isAt("/whatsapp/fila")} onClick={() => setWhatsappOpen(false)} />
                    <DrawerLink to="/agentes" label="Agentes" active={isAt((p) => p === "/agentes" || p.startsWith("/agentes/"))} onClick={() => setWhatsappOpen(false)} />
                    <DrawerLink to="/whatsapp/bot-avisos" label="Bot de Avisos" active={isAt("/whatsapp/bot-avisos")} onClick={() => setWhatsappOpen(false)} />
                    <DrawerLink to="/whatsapp/respostas-rapidas" label="Respostas rápidas" active={isAt("/whatsapp/respostas-rapidas")} onClick={() => setWhatsappOpen(false)} />
                    <DrawerLink to="/whatsapp/sessoes" label="Sessões" active={isAt("/whatsapp/sessoes")} onClick={() => setWhatsappOpen(false)} />
                    <DrawerLink to="/whatsapp/oficial" label="Oficial (Meta)" active={isAt("/whatsapp/oficial")} onClick={() => setWhatsappOpen(false)} />
                    <DrawerLink to="/whatsapp/relatorios" label="Relatórios" active={isAt("/whatsapp/relatorios")} onClick={() => setWhatsappOpen(false)} />
                    <DrawerLink to="/configuracoes/ia" label="Configuração IA" active={isAt("/configuracoes/ia")} onClick={() => setWhatsappOpen(false)} />
                </Drawer>
            )}

            {instagramOpen && (
                <Drawer onClose={() => setInstagramOpen(false)}>
                    <DrawerLink to="/instagram/inbox" label="Inbox" active={isAt("/instagram/inbox")} onClick={() => setInstagramOpen(false)} />
                    <DrawerLink to="/instagram/oficial" label="Oficial (Meta)" active={isAt("/instagram/oficial")} onClick={() => setInstagramOpen(false)} />
                </Drawer>
            )}

            {leadsOpen && (
                <Drawer onClose={() => setLeadsOpen(false)}>
                    <DrawerLink to="/leads" label="Leads" active={isAt("/leads")} onClick={() => setLeadsOpen(false)} />
                    <DrawerLink to="/leads/quentes" label="Leads Quentes" active={isAt("/leads/quentes")} onClick={() => setLeadsOpen(false)} />
                    <DrawerLink to="/tags" label="Tags" active={isAt("/tags")} onClick={() => setLeadsOpen(false)} />
                </Drawer>
            )}

            {relatoriosOpen && (
                <Drawer onClose={() => setRelatoriosOpen(false)}>
                    <DrawerLink to="/relatorios/orderbumps" label="Orderbumps" active={isAt("/relatorios/orderbumps")} onClick={() => setRelatoriosOpen(false)} />
                    <DrawerLink to="/relatorio-grupo" label="Tráfego" active={isAt("/relatorio-grupo")} onClick={() => setRelatoriosOpen(false)} />
                    <DrawerLink to="/vendas" label="Vendas" active={isAt("/vendas")} onClick={() => setRelatoriosOpen(false)} />
                    <DrawerLink to="/relatorio-produtos" label="Produtos" active={isAt("/relatorio-produtos")} onClick={() => setRelatoriosOpen(false)} />
                    <DrawerLink to="/analise-comparativa" label="✨ Análise IA" active={isAt("/analise-comparativa")} onClick={() => setRelatoriosOpen(false)} />
                </Drawer>
            )}

            {adsOpen && (
                <Drawer onClose={() => setAdsOpen(false)}>
                    <DrawerLink to="/ads/dashboards" label="Dashboards" active={isAt((p) => p.startsWith("/ads/dashboards"))} onClick={() => setAdsOpen(false)} />
                    <DrawerLink to="/ads/produto" label="Por produto" active={isAt("/ads/produto")} onClick={() => setAdsOpen(false)} />
                    <DrawerLink to="/ads/contas" label="Contas de anúncio" active={isAt("/ads/contas")} onClick={() => setAdsOpen(false)} />
                </Drawer>
            )}

            {trackingOpen && (
                <Drawer onClose={() => setTrackingOpen(false)}>
                    <DrawerLink to="/tracking/funil" label="Funil de Conversão" active={isAt("/tracking/funil")} onClick={() => setTrackingOpen(false)} />
                    <DrawerLink to="/tracking/visitantes" label="Visitantes" active={isAt("/tracking/visitantes")} onClick={() => setTrackingOpen(false)} />
                    <DrawerLink to="/tracking/leads" label="Checkout Leads" active={isAt("/tracking/leads")} onClick={() => setTrackingOpen(false)} />
                    <DrawerLink to="/tracking/videos" label="Vídeos" active={isAt("/tracking/videos")} onClick={() => setTrackingOpen(false)} />
                    <DrawerLink to="/tracking/config" label="Configuração" active={isAt("/tracking/config")} onClick={() => setTrackingOpen(false)} />
                    <DrawerLink to="/documentacao/snippet-paginas" label="Documentação" active={isAt((p) => p.startsWith("/documentacao"))} onClick={() => setTrackingOpen(false)} />
                </Drawer>
            )}

            {produtosOpen && (
                <Drawer onClose={() => setProdutosOpen(false)}>
                    <DrawerLink to="/produtos" label="Produtos" active={isAt("/produtos")} onClick={() => setProdutosOpen(false)} />
                    <DrawerLink to="/grupos" label="Grupos" active={isAt("/grupos")} onClick={() => setProdutosOpen(false)} />
                    <DrawerLink to="/gastos" label="Gastos" active={isAt("/gastos")} onClick={() => setProdutosOpen(false)} />
                </Drawer>
            )}

        </nav>
    );
}


function BottomItem({ to, icon: Icon, label, active, onClick }) {
    return (
        <Link
            to={to}
            onClick={onClick}
            className={`flex flex-col items-center justify-center flex-1 gap-0.5 transition-colors duration-150 no-tap ${
                active ? "text-brand-300" : "text-ink-4 hover:text-ink-2"
            }`}
        >
            <div className="relative">
                <Icon className="h-5 w-5" strokeWidth={2.2} />
                {active && (
                    <span className="absolute -inset-1 rounded-full bg-brand-500/20 blur-md -z-10" />
                )}
            </div>
            <span className="text-[10px] font-medium">{label}</span>
        </Link>
    );
}

function BottomGroup({ icon: Icon, label, active, open, onClick }) {
    return (
        <div
            onClick={onClick}
            className={`flex flex-col items-center justify-center flex-1 gap-0.5 cursor-pointer transition-colors duration-150 no-tap ${
                active || open ? "text-brand-300" : "text-ink-4 hover:text-ink-2"
            }`}
        >
            <div className="relative">
                <Icon className="h-5 w-5" strokeWidth={2.2} />
                {(active || open) && (
                    <span className="absolute -inset-1 rounded-full bg-brand-500/20 blur-md -z-10" />
                )}
            </div>
            <span className="text-[10px] font-medium">{label}</span>
        </div>
    );
}

function Drawer({ children, onClose }) {
    return (
        <>
            <div
                className="fixed inset-0 bottom-16 bg-black/40 backdrop-blur-sm z-[999]"
                onClick={onClose}
            />
            <div className="fixed bottom-16 left-0 right-0 surface-card !rounded-b-none border-b-0 z-[1001] flex flex-col p-2 animate-slide-up">
                {children}
            </div>
        </>
    );
}

function DrawerLink({ to, label, active, onClick }) {
    return (
        <Link
            to={to}
            onClick={onClick}
            className={`px-4 py-3 rounded-xl text-base transition-colors no-tap ${
                active
                    ? "bg-brand-500/10 text-brand-200 ring-1 ring-brand-500/20"
                    : "text-ink-2 hover:bg-white/[0.04]"
            }`}
        >
            {label}
        </Link>
    );
}
